import { type BlogPost } from '../blogData'

export const phase3: BlogPost[] = [
  {
    slug: 'jsa-automation-guide',
    lang: 'ko',
    category: '안전 가이드',
    title: "JSA 양식 매번 똑같지 않으셨나요? | 작업안전분석 자동 생성 후기",
    standfirst: "JSA 작성에 걸리는 시간이 평균 2.3시간입니다. Heinrich AI는 작업 설명 한 줄로 위험 요인·방지 대책까지 자동 완성합니다.",
    date: '2026.05.25',
    hideDate: true,
    readMin: 12,
    cover: '/blog/jsa-automation-guide/page_01_cover.jpg',
    featured: false,
    blocks: [
      { type: 'p', html: "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━" },
      { type: 'p', html: "안녕하세요, 산업안전 AI 'Heinrich' 팀입니다 👋" },
      { type: 'p', html: "오늘은 JSA(작업안전분석)에 대해 안전관리자분들이 잘 안 하시는 얘기를 한번 꺼내보려고 합니다." },
      { type: 'p', html: "🤫 다들 알지만 말 안 하는 얘기" },
      { type: 'p', html: "\"JSA는 한 번 만들어 놓고 계속 돌려쓴다.\"" },
      { type: 'p', html: "혹시 공감하시나요? 저희도 안전관리자분들 인터뷰하면서 가장 많이 들은 얘기였습니다." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_01_cover.jpg", caption: "JSA 2분 자동 생성" },
      { type: 'h2', text: "JSA를 매번 새로 못 만드는 이유 — 진짜 문제 3가지 ⚠️" },
      { type: 'p', html: "처음엔 시간 문제라고 생각했어요. JSA 한 건에 평균 2시간이 들어가니까 매일 새로 만들 만하다고요." },
      { type: 'p', html: "그런데 인터뷰를 더 해보니 다른 문제가 있었습니다." },
      { type: 'p', html: "① 작성자에 따라 결과가 달라짐" },
      { type: 'ul', items: ["신입 안전관리자: 빠지는 항목이 있음", "베테랑: 다른 항목이 들어감", "결국 표준화가 안 됨"] },
      { type: 'p', html: "② 시간이 부족함" },
      { type: 'ul', items: ["JSA 1건 평균 2시간", "매일 작업이 바뀌는데 매일 새로 작성?", "현실적으로 어려움"] },
      { type: 'p', html: "③ 결국 \"표준 JSA 돌려쓰기\"" },
      { type: 'ul', items: ["한 번 잘 만든 JSA를 계속 사용", "서류와 실제 작업 사이에 점점 거리가 생김"] },
      { type: 'h2', text: "📌 결과: 서류는 있는데 현장과 맞지 않는 상황이 생깁니다." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_02_real_problem.jpg", caption: "진짜 문제 3가지" },
      { type: 'h2', text: "그래서 이런 AI를 만들었습니다 🔧" },
      { type: 'p', html: "작업 설명 텍스트만 입력하면 그 작업에 맞는 JSA를 그때그때 새로 만들어주는 AI를 만들었어요." },
      { type: 'p', html: "✅ 평균 2분 안에 단계별 위험분석 완료" },
      { type: 'p', html: "✅ Excel 파일로 출력" },
      { type: 'p', html: "✅ 인쇄·서명해서 그대로 사용 가능" },
      { type: 'p', html: "매일 작업이 바뀌어도 매번 새 JSA를 만들 수 있게 됐습니다." },
      { type: 'h2', text: "5단계로 작동합니다 ⚙️" },
      { type: 'p', html: "입력하는 순간 이렇게 진행돼요." },
      { type: 'ul', items: ["STEP 1 — 작업 설명을 단계별로 분해 (자연어 텍스트 → 개별 단계)", "STEP 2 — 유사 사고 검색 (40만건 사례 벡터 매칭)", "STEP 3 — 단계별 위험요인 식별 (사고 데이터 근거)", "STEP 4 — 현재 안전조치 평가 (공학적 / 관리적 / 보호구)", "STEP 5 — 개선대책 생성 (위험도 기준 이상 단계만)"] },
      { type: 'p', html: "위험도가 높은 단계에만 개선대책을 자동 생성하기 때문에, 모든 단계에 일일이 추가 안전조치를 적지 않아도 됩니다." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_03_workflow.jpg", caption: "5단계 자동 작동 원리" },
      { type: 'h2', text: "실제 출력물 그대로 보여드릴게요 📄" },
      { type: 'p', html: "설명만으로는 잘 안 와닿으니 직접 한 번 돌려본 결과물을 그대로 보여드릴게요." },
      { type: 'p', html: "📝 사용자 입력" },
      { type: 'p', html: "\"V벨트·기어 점검, 공정 셧다운 중 단독 작업\"" },
      { type: 'p', html: "이 한 문장만 입력했더니 다음과 같은 결과가 나왔습니다." },
      { type: 'p', html: "✅ 7단계 작업 자동 분해" },
      { type: 'p', html: "✅ 위험요인 + 통제 매트릭스" },
      { type: 'p', html: "✅ KOSHA P 140 양식에 맞춘 표 구조" },
      { type: 'p', html: "✅ 인쇄·서명 가능한 Excel 출력" },
      { type: 'p', html: "각 위험에는 안전 통제방안과 책임자(Eng/Adm/PPE)까지 자동 매칭됩니다." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_04_real_jsa.jpg", caption: "실제 자동 생성된 JSA Excel" },
      { type: 'h2', text: "시간 비교 — 95% 절감 ⏱️" },
      { type: 'p', html: "기존 수동 작성과 비교해드릴게요." },
      { type: 'ul', items: ["기존 수동: ~2시간 / 1건", "Heinrich: ~2분 / 1건", "시간 절감: 약 95%"] },
      { type: 'p', html: "수치만 보면 인상적이지만, 사실 더 중요한 건 다른 점이에요." },
      { type: 'callout', label: "💡 진짜 변화", items: ["\"매번 새로 만들 수 있다\"는 점입니다. 재활용 JSA 시대가 끝나고, 진짜 그 작업에 맞는 분석이 매일 가능해진다는 거죠."] },
      { type: 'img', src: "/blog/jsa-automation-guide/page_05_time.jpg", caption: "시간 비교" },
      { type: 'h2', text: "자주 받는 질문 ❓" },
      { type: 'p', html: "Q. 정말 2분이 걸리나요?" },
      { type: 'p', html: "A. 네, 작업 설명을 입력하시고 결과 받기까지 평균 2분입니다." },
      { type: 'p', html: "Q. 어떤 작업까지 가능한가요?" },
      { type: 'p', html: "A. 산업현장의 일반적인 작업이면 거의 다 가능합니다. 화학공정, 건설, 제조, 물류 등." },
      { type: 'p', html: "Q. 출력 양식은 KOSHA 표준인가요?" },
      { type: 'p', html: "A. KOSHA P 140 양식을 기본으로 하며, 사업장 커스텀 템플릿도 Pro 플랜부터 지원합니다." },
      { type: 'cta', title: "Heinrich와 함께 안전관리 업무를 자동화하세요", body: "👉 정리하자면", label: "Heinrich 무료로 시작하기 →", href: "/signup" },
      { type: 'h2', text: "📌 JSA의 진짜 문제는 시간뿐 아니라 작성자별 차이 + 현장 괴리입니다." },
      { type: 'h2', text: "📌 작업 설명 한 문장 → JSA Excel 2분 (95% 시간 절감)." },
      { type: 'h2', text: "📌 5단계 자동 워크플로우 — 분해 → 사례 매칭 → 식별 → 평가 → 개선대책." },
      { type: 'h2', text: "📌 매일 다른 작업, 매일 다른 JSA가 가능해집니다." },
      { type: 'p', html: "직접 써보시려면" },
      { type: 'p', html: "설명만으로는 잘 안 와닿을 수 있어요. Heinrich는 Free 플랜으로 시작 가능합니다. 카드 등록 없이 가입 30초, 첫 JSA가 5분 안에 손에 쥐어집니다." },
      { type: 'cta', title: "Heinrich와 함께 안전관리 업무를 자동화하세요", body: "👉 체험해보기: https://dasancms.co.kr/dasan-ai/chatbot/demo", label: "Heinrich 무료로 시작하기 →", href: "https://dasancms.co.kr/dasan-ai/chatbot/demo" },
      { type: 'p', html: "작업 설명을 한 문장 입력해보세요. 매일 다른 작업, 매일 다른 JSA가 나오는지 직접 확인해보실 수 있습니다." },
      { type: 'p', html: "써보신 후기는 댓글로 남겨주시면 정말 감사하겠습니다 💪 안전관리자분들의 피드백이 다음 개선의 가장 큰 단서가 됩니다." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_06_cta.jpg", caption: "Image showing JSA 양식 매번 똑같지 않으셨나요? | 작업안전분석 자동 생성 후기" },
      { type: 'p', html: "도움이 되셨길 바랍니다." },
      { type: 'h2', text: "JSA #작업안전분석 #JSA양식 #산업안전 #안전관리자 #위험성평가 #산업안전AI #안전관리 #스마트안전 #업무자동화 #안전교육 #산업재해예방 #KOSHA #Heinrich #다산AI #안전보건 #SaaS" }
    ]
  },
  {
    slug: 'jsa-automation-guide',
    lang: 'en',
    category: 'Safety Guide',
    title: "Tired of the Same Old JSA Form? | Review of AI-Generated Job Safety Analysis",
    standfirst: "JSA takes an average of 2.3 hours to complete manually. Heinrich AI generates hazards and controls from a single line of work description.",
    date: '2026.05.25',
    hideDate: true,
    readMin: 6,
    cover: '/blog/jsa-automation-guide/page_01_cover.jpg',
    featured: false,
    blocks: [
      { type: 'p', html: "━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━" },
      { type: 'p', html: "Hello, this is the Heinrich industrial safety AI team 👋" },
      { type: 'p', html: "Today, we would like to address a topic regarding JSA (Job Safety Analysis) that safety managers rarely discuss openly." },
      { type: 'p', html: "🤫 The secret everyone knows but doesn't talk about:" },
      { type: 'p', html: "\"A JSA is written once and reused forever.\"" },
      { type: 'p', html: "Do you agree? This was the most common feedback we received during interviews with safety managers." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_01_cover.jpg", caption: "JSA generated in 2 minutes" },
      { type: 'h2', text: "Why JSAs aren't rewritten every time — 3 real problems ⚠️" },
      { type: 'p', html: "At first, we thought it was just a time issue. Since a JSA takes an average of 2 hours per case, it's hard to write a new one every day." },
      { type: 'p', html: "But further interviews revealed other issues:" },
      { type: 'p', html: "① Results vary depending on the author" },
      { type: 'ul', items: ["New safety managers: miss key hazards", "Veterans: include different hazards", "Consequently, standardization is impossible"] },
      { type: 'p', html: "② Lack of time" },
      { type: 'ul', items: ["JSA averages 2 hours per case", "Tasks change daily, but write a new one every day?", "Not feasible in reality"] },
      { type: 'p', html: "③ Reusing a standard JSA template" },
      { type: 'ul', items: ["Keep using one well-made JSA", "A gap forms between the document and actual site work"] },
      { type: 'h2', text: "📌 Result: Paperwork exists, but it doesn't match the actual site conditions." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_02_real_problem.jpg", caption: "3 real problems" },
      { type: 'h2', text: "So we built this AI 🔧" },
      { type: 'p', html: "We built an AI that generates a new, customized JSA every time — from a plain text description of the work." },
      { type: 'ul', items: ["Average 2 minutes to complete step-by-step risk analysis", "Export to Excel file", "Print, sign, and use directly"] },
      { type: 'p', html: "Even if the job changes daily, a new JSA can be created every time." },
      { type: 'h2', text: "Operates in 5 steps ⚙️" },
      { type: 'p', html: "Here is what happens the moment you submit:" },
      { type: 'ul', items: ["STEP 1 — Break work description into steps (natural text → individual steps)", "STEP 2 — Search similar accidents (vector matching across 400K+ cases)", "STEP 3 — Identify hazards per step (grounded in accident data)", "STEP 4 — Evaluate current safeguards (engineering / administrative / PPE)", "STEP 5 — Generate improvement measures (only where risk score demands it)"] },
      { type: 'p', html: "Because improvement measures are automatically generated only for high-risk steps, you don't have to write additional measures for every single step." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_03_workflow.jpg", caption: "5-step automatic workflow" },
      { type: 'h2', text: "Here is the actual output document 📄" },
      { type: 'p', html: "To make it concrete, here is the actual result of a JSA run." },
      { type: 'p', html: "📝 User input example:" },
      { type: 'p', html: "\"V-belt and gear inspection, solo work during process shutdown\"" },
      { type: 'p', html: "This single line automatically generates:" },
      { type: 'p', html: "✅ 7-step job breakdown" },
      { type: 'p', html: "✅ Hazard and control matrix" },
      { type: 'p', html: "✅ Table structure matching KOSHA P-140 standard" },
      { type: 'p', html: "✅ Printable Excel output" },
      { type: 'p', html: "Each hazard is automatically matched with safety controls and responsible parties (Eng/Adm/PPE)." },
      { type: 'img', src: "/blog/jsa-automation-guide/page_04_real_jsa.jpg", caption: "Actual JSA Excel automatically generated" },
      { type: 'h2', text: "Time comparison — 95% reduction ⏱️" },
      { type: 'p', html: "Let's compare it to traditional manual writing." },
      { type: 'ul', items: ["Traditional manual: ~2 hours / case", "Heinrich: ~2 minutes / case", "Time saved: about 95%"] },
      { type: 'p', html: "The numbers are impressive, but the real benefit is something else." },
      { type: 'callout', label: "💡 The Real Change", items: ["\"You can create a new one every time.\" The era of recycled JSAs is over, and tailored analysis for the actual job is possible every day."] },
      { type: 'img', src: "/blog/jsa-automation-guide/page_05_time.jpg", caption: "Time comparison" },
      { type: 'h2', text: "Frequently Asked Questions ❓" },
      { type: 'p', html: "Q. Does it really take 2 minutes?" },
      { type: 'p', html: "A. Yes, from entering the description to receiving the result, it averages 2 minutes." },
      { type: 'p', html: "Q. What kind of jobs are supported?" },
      { type: 'p', html: "A. Most typical industrial site jobs: chemical processes, construction, manufacturing, logistics, etc." },
      { type: 'p', html: "Q. Is the output format KOSHA standard?" },
      { type: 'p', html: "A. It is based on the KOSHA P-140 standard. Site-specific custom templates are supported from the Pro plan." },
      { type: 'cta', title: "Automate safety management with Heinrich", body: "👉 To summarize", label: "Start Heinrich free →", href: "/signup" },
      { type: 'h2', text: "📌 The real problem with JSA is not just time, but author discrepancies + site gap." },
      { type: 'h2', text: "📌 Work description → JSA Excel in 2 minutes (95% time saved)." },
      { type: 'h2', text: "📌 5-step automated workflow — breakdown → match → identify → evaluate → improve." },
      { type: 'h2', text: "📌 Different job daily, different JSA daily becomes possible." },
      { type: 'p', html: "Try it yourself:" },
      { type: 'p', html: "Heinrich can be started on a Free plan. No card required, signup in 30 seconds. Get your first JSA in 5 minutes." },
      { type: 'cta', title: "Automate safety management with Heinrich", body: "👉 Try the demo: https://dasancms.co.kr/dasan-ai/chatbot/demo", label: "Start Heinrich free →", href: "https://dasancms.co.kr/dasan-ai/chatbot/demo" },
      { type: 'p', html: "Try entering a one-sentence work description. See for yourself if a different JSA is generated every day." },
      { type: 'p', html: "We appreciate your feedback. Tell us in the comments which forms consume the most time, as your feedback is the key to our next improvement 💪" },
      { type: 'img', src: "/blog/jsa-automation-guide/page_06_cta.jpg", caption: "Image showing JSA Form automation" },
      { type: 'p', html: "Hope this was helpful." },
      { type: 'h2', text: "#JSA #JobSafetyAnalysis #IndustrialSafety #SafetyManager #RiskAssessment #IndustrialSafetyAI #SmartSafety #Automation #SafetyTraining #AccidentPrevention #KOSHA #Heinrich #DasanAI #OccupationalSafety" }
    ]
  }
]
